// URL state for shareable visual presets — palette + fractal index synced
// to the query string so links recreate exactly what the user saw.
export function clampInt(n, lo, hi) {
  if (!Number.isFinite(n)) return lo;
  return Math.max(lo, Math.min(hi, Math.trunc(n)));
}

const VALID_VIEWS = ['fly', 'orbit', 'stabilized'];
const DEFAULT_VIEW = 'stabilized';
const DEFAULT_FRACTAL = 2; // 0=mandelbulb 1=sacred-lattice 2=lava-lamp 3=pointilized

export function parseView(raw) {
  return VALID_VIEWS.includes(raw) ? raw : DEFAULT_VIEW;
}

export function parseUrlParams(searchString) {
  const p = new URLSearchParams(searchString || '');
  const rawFractal = p.get('fractal');
  return {
    palette: clampInt(parseInt(p.get('palette') || '0', 10), 0, 7),
    fractal: rawFractal === null
      ? DEFAULT_FRACTAL
      : clampInt(parseInt(rawFractal, 10), 0, 3),
    view: parseView(p.get('view')),
  };
}

export function readUrlState() {
  if (typeof window === 'undefined') return { palette: 0, fractal: DEFAULT_FRACTAL, view: DEFAULT_VIEW };
  return parseUrlParams(window.location.search);
}

export function writeUrlState({ palette, fractal, view }) {
  if (typeof window === 'undefined') return;
  const u = new URL(window.location.href);
  u.searchParams.set('palette', String(clampInt(palette, 0, 7)));
  u.searchParams.set('fractal', String(clampInt(fractal, 0, 2)));
  u.searchParams.set('view', parseView(view));
  window.history.replaceState(null, '', u.toString());
}
